import '.c{display:flex;}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import '.d{justify-content:center;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.c9{background:var(--palette-white);}.ssr-plugin'
import '.o{flex-grow:1;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.b3{max-width:77.5rem;}.ssr-plugin'
import '.cj{justify-content:stretch;}.ssr-plugin'
import '.ck{position:sticky;}.ssr-plugin'
import '.cl{top:0px;}.ssr-plugin'
import '.cm{z-index:10;}.ssr-plugin'
import '.cn{padding-block:1rem;}.ssr-plugin'
import '.co{height:3rem;}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.cp{flex-wrap:wrap;}.ssr-plugin'
import '.cq{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b2{margin-top:2rem;}.ssr-plugin'
import '.h5{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="c a6 d g c9"
      >
        <div className="o c h d g"
        >
          <div className="b3 c g cj ck cl cm"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cn co c v h cp"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="cq c g a6 b2 h5 b3"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
